import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/identities")({
  component: IdentitiesLayout,
});

function IdentitiesLayout() {
  return <Outlet />;
}
